/* eslint-disable */
/**
 * Select the current `locale`
 * @param {any} state The state management `state`
 * @returns {I18nEntityLocale} The current `locale`
 */
const i18nLocaleSelector = (state) => state.i18n.locale;

export default i18nLocaleSelector;
